import axios from "./Api";

export const getEvents = () => {
    return axios.get('/events/?page=1').then(res => res.data[0])
}
